import { render } from "./CreateUserInputUserInfo.vue?vue&type=template&id=0d32e71b&scoped=true"
import script from "./CreateUserInputUserInfo.vue?vue&type=script&lang=js"
export * from "./CreateUserInputUserInfo.vue?vue&type=script&lang=js"

import "./CreateUserInputUserInfo.vue?vue&type=style&index=0&id=0d32e71b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d32e71b"]])

export default __exports__